var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bg)?_c('section',[_c('img',{staticClass:"w-100",attrs:{"src":_vm.bg,"alt":"Banner Image"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }